module.exports = __webpack_public_path__ + "img/icon-04.a1f3dc0b.png";